import { useEffect } from 'react';
import { useAppStore } from '@/store/appStore';

/**
 * This hook is used to close the window and store the auth details in the app store.
 */
export function useCloseWindow() {
  const setAuthDetails = useAppStore((state) => state.setAuthDetails);

  const messageHandler = (event: MessageEvent) => {
    if (event.data.action === 'CLOSE_WINDOW') {
      (event.source as Window)?.close();
      setAuthDetails({
        accessToken: event.data.access_token,
        refreshToken: event.data.refresh_token,
        userId: event.data.user_info_principal_id,
        userName: event.data.user_info_principal_name,
        userEmail: event.data.user_info_principal_email,
      });
    }
  };
  
  useEffect(() => {
    window.addEventListener("message", messageHandler, false);
    return () => window.removeEventListener("message", messageHandler, false);
  }, []);
}